module.exports = __webpack_public_path__ + "static/media/rocky-shore2.68666158.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pic-collage/rocky-shore2.jpg
// module id = 208
// module chunks = 0